import { Injectable } from '@angular/core';
import { filter, Observable, switchMap, take } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { Status, Store as StoreModel } from '@core/models';
import { environment } from '../../../../environments/environment';
import { IResponseSuccess } from '@core/interfaces';
import { AppState } from '@store/reducers';
import { selectStore } from '@store/selectors';

@Injectable({
	providedIn: 'root',
})
export class StatusService {
	store$: Observable<StoreModel | null>;
  
	constructor(
		private http: HttpClient,
		private store: Store<AppState>
	) {
		this.store$ = this.store.select(selectStore);
	}

	getStates(): Observable<IResponseSuccess<Status>> {
		return this.store$.pipe(
			filter(store => store !== null),
			switchMap(store => {
				return this.http.get<IResponseSuccess<Status>>(`${environment.microConfiguraciones}/estados`, {
					headers: { authorization: store.apiKey },
				});
			}),
			take(1)
		);
	}
}
